import AppIcon from 'components/common/AppIcon/AppIcon';
import React from 'react';
import styled from 'styled-components';
import {colors} from 'styles/shared';

const EmptyTabContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 15rem;
`;

const ImageContainer = styled.div`
  width: 10.4rem;
  height: 10.4rem;
  border-radius: 50%;
  background: ${colors.blue_lighter};
  margin-bottom: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  max-width: 23.8rem;
  text-align: center;
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.4rem;
  color: ${colors.blue_main};
`;

function EmptyTab() {
  return (
    <EmptyTabContainer>
      <ImageContainer>
        <AppIcon name="direction" />
      </ImageContainer>

      <Title>Search for a destination</Title>
    </EmptyTabContainer>
  );
}

export default EmptyTab;
